<template>
  <ul class="c-breadcrumb">
    <li class="c-breadcrumb__item">
      <a href="/" class="c-breadcrumb__link">Home</a>
    </li>
    <li class="c-breadcrumb__item">
      <a href="/bukareksa" class="c-breadcrumb__link">BukaReksa</a>
    </li>
    <li v-for="(link, index) in otherLinks" :key="index" class="c-breadcrumb__item">
      <a :href="link.link_url" class="c-breadcrumb__link" data-no-turbolink="true">{{ link.link_title }}</a>
    </li>
    <li v-if="Object.keys(thisPage).length" class="c-breadcrumb__item is-active">
      <div class="c-breadcrumb__link">
        {{ thisPage.link_title }}
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    otherLinks: {
      type: Array,
      default: () => [],
    },
    thisPage: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
<style lang="scss" scoped>
.c-breadcrumb {
  font-size: 12px;
  color: #999;
  margin: 0;
  padding: 0;

  &__item {
    position: relative;
    display: block;
    padding: 0;
    margin-bottom: 0;
    margin-right: 24px;
    float: left;

    &::before {
      content: '\203A';
      position: absolute;
      left: -12px;
      top: -3px;
      font-size: 16px;
    }

    &:first-child:before {
      content: ' ';
    }

    &:last-child {
      .c-breadcrumb__link {
        color: #333;
      }
    }
  }

  &__link {
    display: block;
    color: #999;
    cursor: pointer;
    max-width: 600px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>
